import script from "./StoreDiscountLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreDiscountLimit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputField from "@/components/neue/InputField.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { InputField, NeueLoading, SelectInput, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputField, NeueLoading, SelectInput, SettingsSection }, script.__o.components);}